import { render, staticRenderFns } from "./Voip.vue?vue&type=template&id=b583aa06&scoped=true&"
import script from "./Voip.vue?vue&type=script&lang=js&"
export * from "./Voip.vue?vue&type=script&lang=js&"
import style0 from "./Voip.vue?vue&type=style&index=0&id=b583aa06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b583aa06",
  null
  
)

export default component.exports